export default __webpack_public_path__ + "static/media/logo.fb997a18.svg";